import { Box, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { getSettings } from "../../services/Auth"; // <-- API call function
import AppContainer from "../../components/containers/AppContainer";
import { Padding } from "@mui/icons-material";
import { APP_LOGO } from "../../assets";

const PrivacyPolicyPage = () => {
  const [privacyPolicy, setPrivacyPolicy] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchPrivacyPolicy();
  }, []);

  const fetchPrivacyPolicy = async () => {
    setIsLoading(true);
    try {
      const res = await getSettings();
      if (res.status === 200) {
        setPrivacyPolicy(res.data.data.privacyPolicy);
      }
    } catch (error) {
      console.error("Failed to load privacy policy:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Stack alignItems={"center"}>
      <AppContainer
        styleProps={{
          minWidth: "600px",
          mt: 5,
          p: 5,
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <img src={APP_LOGO.circularLogo} style={{ height: "100px" }} />
        <Typography variant="h4" gutterBottom>
          Privacy Policy
        </Typography>
        {isLoading ? (
          <Typography>Loading...</Typography>
        ) : (
          <Box
            sx={{ width: "800px" }}
            dangerouslySetInnerHTML={{ __html: privacyPolicy }}
          />
        )}
      </AppContainer>
    </Stack>
  );
};

export default PrivacyPolicyPage;
